// Recovered compiled webpack factory 93913. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      HTML_LIMITED_BOT_UA_RE: function () {
        return n.HTML_LIMITED_BOT_UA_RE;
      },
      HTML_LIMITED_BOT_UA_RE_STRING: function () {
        return o;
      },
      getBotType: function () {
        return l;
      },
      isBot: function () {
        return s;
      },
    }));
  let n = r(14029),
    a = /Googlebot(?!-)|Googlebot$/i,
    o = n.HTML_LIMITED_BOT_UA_RE.source;
  function i(e) {
    return n.HTML_LIMITED_BOT_UA_RE.test(e);
  }
  function s(e) {
    return a.test(e) || i(e);
  }
  function l(e) {
    return a.test(e) ? "dom" : i(e) ? "html" : void 0;
  }
}
